// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35fFI","right":"styles_right__HLC3P"};